<template>
  <v-dialog v-model="model" @click:outside="close" max-width="500">
    <HandleFeedbackUpdateLink
      v-if="loading || feedback.show"
      :done="feedback.show"
      :error="feedback.error"
      :variant="variant"
      :removed="feedback.removed"
      :updated="feedback.updated"
    />
    <v-card v-else class="pa-4">
      <v-card-title class="pl-0 pb-6 text-h6">
        Deseja duplicar a solicitação?
      </v-card-title>
      <v-card-text class="ml-n4">
        Uma nova solicitação será criada com uma cópia das turmas.
      </v-card-text>
      <v-text-field
        outlined
        label="Nome"
        v-model="name"
        :rules="[rules.required, rules.min]"
      ></v-text-field>
      <v-checkbox
        class="mt-n4"
        v-model="checkbox"
        :label="'Atualizar dados das turmas'"
      ></v-checkbox>
      <div v-if="checkbox">
        <v-row>
          <v-col col="6"
            ><v-text-field
              dense
              outlined
              type="number"
              label="Ano"
              v-model="ano"
              :rules="[rules.required]"
            >
            </v-text-field
          ></v-col>
          <v-col col="6">
            <v-select
              dense
              v-model="periodo"
              :items="[1, 2, 3, 4]"
              label="Período"
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <p class="text-caption">
          * Serão atualizadas a quantidade de discentes, horário e docentes.
          A turma será removida caso não esteja ofertada para o
          período selecionado.
        </p>
      </div>
      <v-card-actions class="pa-0 pt-7">
        <v-btn v-if="!validate" small class="grey" dark>Criar</v-btn>
        <v-btn v-else small class="blue" dark @click="handleCriar"
          >Criar</v-btn
        >
        <v-btn small plain @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  duplicateRequest,
  duplicateRequestAndUpdate
} from "@/api/requests";

import HandleFeedbackUpdateLink from "./HandleFeedbackUpdateLink.vue";

export default {
  name: "HandleDuplicateClassesRequest",
  components: {
    HandleFeedbackUpdateLink
  },
  props: {
    data: Object
  },
  data() {
    return {
      name: "",
      checkbox: false,
      ano: 2026,
      periodo: 1,
      model: true,
      loading: false,
      variant: "default",
      feedback: {
        error: false,
        show: false,
        removed: [],
        updated: []
      },
      rules: {
        required: value => !!value || "Campo obrigatório.",
        min: v => v.length >= 5 || "Min 5 caracteres."
      }
    };
  },
  computed: {
    validate() {
      return this.checkbox
        ? this.name.length >= 5 && Number(this.ano) >= 2010
        : this.name.length >= 5;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleCriar() {
      if (!this.validate) return;
      if (!this.checkbox) this.handleDuplicate();
      else this.handleDuplicateAndUpdate();
    },
    handleDuplicate() {
      this.loading = true;
      duplicateRequest({
        name: this.name,
        hash: this.data.hash
      })
        .then(res => {
          this.$emit("duplicate", res);
          this.$emit("close");
        })
        .catch((e) => {
          this.feedback.error = true;
          this.feedback.show = true;
          console.log("Error: ", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDuplicateAndUpdate() {
      this.loading = true;
      this.variant = "full";
      duplicateRequestAndUpdate({
        name: this.name,
        hash: this.data.hash,
        ano: this.ano,
        periodo: this.periodo
      })
        .then(res => {
          this.feedback = {
            show: true,
            removed: res.removed,
            updated: res.updated
          };

          this.$emit("duplicate", res.link);
          //this.$emit("close");
        })
        .catch((e) => {
          this.feedback.error = true;
          this.feedback.show = true;
          console.log("Error: ", e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
